import React from 'react';
import type { TurnSeparatorData } from '../types';
import { useTheme } from '../../../../contexts/ThemeContext';

// Horizontal chapter break between turns on the ChatTrail. Renders
// as a centered "Turn N" label flanked by gradient-fade horizontal
// rules — a cartographic milestone that tells the eye "this is
// where one turn ends and the next begins" without competing
// visually with the actual content nodes.
//
// Non-interactive (no click, no hover, pointer-events:none) so it
// never gets in the way of canvas pan/zoom or node interactions.
export const TurnSeparatorNode: React.FC<{ data: TurnSeparatorData }> = ({
  data,
}) => {
  const { darkMode } = useTheme();
  const ruleColor = darkMode ? 'text-emerald-500/40' : 'text-emerald-600/40';
  return (
    <div
      className="flex items-center gap-3 w-full"
      style={{ pointerEvents: 'none' }}
      aria-hidden
    >
      {/* Each rule is a relative wrapper carrying the static gradient
          PLUS a one-shot shimmer overlay that sweeps L→R when the
          separator first mounts. The shimmer settles transparent so
          the static rule is what remains. */}
      <div className="relative flex-1 h-px overflow-hidden">
        <div className={`absolute inset-0 bg-gradient-to-l from-current to-transparent ${ruleColor}`} />
        <div className="absolute inset-0 chatdag-turnsep-shimmer" />
      </div>
      <span
        className={`text-[10px] uppercase tracking-[0.25em] font-mono font-semibold whitespace-nowrap px-2 ${
          darkMode ? 'text-emerald-300/70' : 'text-emerald-700/70'
        }`}
      >
        · {data.label} ·
      </span>
      <div className="relative flex-1 h-px overflow-hidden">
        <div className={`absolute inset-0 bg-gradient-to-r from-current to-transparent ${ruleColor}`} />
        <div className="absolute inset-0 chatdag-turnsep-shimmer" />
      </div>
    </div>
  );
};

export default TurnSeparatorNode;
